import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { useRef, useState } from 'react';
import {
  trackCtaClickedStoreV2,
  trackSectionViewedStoreV2,
} from 'src/modules/parkplusStoreV2/utils/events';
import { Button } from 'ui-v2/components/Button';
import AddReviewPopup from '../../Popups/AddReviewPopup';

type AddRatingPropType = {
  data: {
    title: string;
    subtitle: string;
    imgUrl: string;
    sku: string;
    id: number;
  };
  hideAdd: () => void;
};
export const AddRating = ({ data, hideAdd }: AddRatingPropType) => {
  const [show, setShow] = useState(false);
  const rootRef = useRef();
  const isInViewport = useComponentInViewport(rootRef, {
    threshold: 1,
  });

  if (isInViewport) {
    trackSectionViewedStoreV2('add review');
  }

  return (
    <div ref={rootRef}>
      <Button
        label="Add rating"
        variant="tertiary"
        size="small"
        style={{
          marginTop: '12px',
        }}
        onClick={() => {
          trackCtaClickedStoreV2('add review');
          setShow(true);
        }}
      />
      <AddReviewPopup
        show={show}
        onClose={() => setShow(false)}
        data={data}
        hideAdd={hideAdd}
      />
    </div>
  );
};
